import patientApiFetch from './patientApiFetch';

const getAffiliationAsync = async (affiliationId) => {
  const url = `api/affiliations/${affiliationId}`;

  try {
    const response = await patientApiFetch(url, {
      method: 'GET',
    });

    const { affiliation } = await response.json();

    return { affiliation };
  } catch (error) {
    throw new Error('there was an unexpected error fetching affiliation')
  }
};

export default getAffiliationAsync;



// WEBPACK FOOTER //
// ./registration-react/api/getAffiliationAsync.js